// Backend collection name -> frontend route that lists it. Used to jump
// straight to the right module page from a notification or a search result.
export const COLLECTION_ROUTES = {
  // CRM
  customers: "/crm/customers",
  leads: "/crm/leads",
  invoices: "/crm/invoices",
  sales_orders: "/crm/sales-orders",
  service_contracts: "/crm/service-contracts",

  // Purchases
  suppliers: "/purchases/suppliers",
  purchase_requisitions: "/purchases/requisitions",
  purchase_orders: "/purchases/orders",
  supplier_invoices: "/purchases/invoices",
  goods_received: "/purchases/grn",

  // Accounting
  chart_of_accounts: "/accounting/chart",
  journal_entries: "/accounting/journals",
  expenses: "/accounting/expenses",
  deposits: "/accounting/deposits",
  fund_transfers: "/accounting/transfers",
  budgets: "/accounting/budgets",
  petty_cash: "/accounting/petty-cash",

  // Inventory
  product_categories: "/inventory/categories",
  products: "/price-list",
  office_items: "/inventory/office-items",
  equipments: "/inventory/equipments",
  stock_movements: "/inventory/movements",

  // Assets
  assets: "/assets/register",
  asset_maintenance: "/assets/maintenance",

  // HRM
  employees: "/hrm/employees",
  departments: "/hrm/departments",
  designations: "/hrm/designations",
  leaves: "/hrm/leaves",
  payroll: "/hrm/payroll",
  holidays: "/hrm/holidays",

  // Service
  tickets: "/service/tickets",
  work_orders: "/service/work-orders",
  device_installs: "/service/device-registry",
};

export const collectionLabel = (collection) =>
  collection.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
